import { login } from "./login";
import { home } from './home';
import { BalanceHours } from './BalanceHours';
import { carousel } from './carousel';
import { holiday } from './holiday';
import { leftMenu } from './leftMenu';
import { leftMenuFeatures } from "./leftMenuFeatures";
import { newHeader } from './newHeader';
import { newPoint } from './newPoint';
import { Perfil } from './Perfil';
import { perfilChangeLinkedin } from './perfilChangeLinkedin'
import { termsOfUse } from './termsOfUse';
import { privacyPolicies } from './privacyPolicies';
import { documents } from './documents'


export const global = {
  translation: {
    ...login,
    ...home,
    ...BalanceHours,
    ...carousel,
    ...holiday,
    ...leftMenu,
    ...leftMenuFeatures,
    ...newHeader,
    ...newPoint,
    ...Perfil,
    ...perfilChangeLinkedin,
    ...termsOfUse,
    ...privacyPolicies,
    ...documents
  }
}


// WEBPACK FOOTER //
// ./src/resources/ptPT/global.js